<template>
  <FormCadastro
    :title="'Informações da transação programada' + (transacao.ID_TRANSACAO_PROGRAMADA ? '- ' + transacao.ID_TRANSACAO_PROGRAMADA : '')"
    :loading="loading"
    @voltar="voltar"
    @salvar="salvar"
    :exibirBotoes="exibirBotoes"
    :dataInclusao="transacao.DATA_INCLUSAO"
    :usuarioInclusao="transacao.USUARIO_INCLUSAO"
    :dataAlteracao="transacao.DATA_ALTERACAO"
    :usuarioAlteracao="transacao.USUARIO"
    :botoesMenu="botoesMenu"
    @botoesMenu="clickMenu"
  >
    <div class="row">
      <div class="col-md-2">
        <b-form-group label="">
          <b-form-radio
            v-model="transacao.PAGAR_RECEBER"
            name="pag-rec"
            value="R" 
            @change="trocouPagarReceber"
          >
            Receber
          </b-form-radio>
          <b-form-radio
            v-model="transacao.PAGAR_RECEBER"
            name="pag-rec"
            value="P"
            @change="trocouPagarReceber"
          >
            Pagar
          </b-form-radio>
        </b-form-group>
      </div>
      <div class="col-md-10">
        <SearchBoxEmitente 
          ref="emitente" 
          v-model="transacao.ID_EMITENTE" 
          :incluir="true" 
          :alterar="true" 
        />
      </div>
    </div>
    <div class="row" style="margin-top: 20px;">
      <div class="col-md-2">
      </div>
      <div class="col-md-10">
        <SearchBoxPlanoFinanceiro
          ref="planoFinanceiro"
          v-model="transacao.ID_PLANO_FINANCEIRO"
          :pagarReceber="(transacao.PAGAR_RECEBER == 'R' ? 'C' : 'D')"
        />
      </div>
    </div>
    <div class="row" style="margin-top: 20px;">
      <div class="col-md-4">
        <b-form-group label="Descrição Contrato:">
          <b-form-input
            type="text"
            v-model="transacao.DESCRICAO"
            placeholder="Descrição Contrato"
          ></b-form-input>
        </b-form-group>
      </div>
      <div class="col-md-4">
        <b-form-group label="Data Início:">
          <b-form-input
            type="date"
            v-model="transacao.DATA_INICIO"
            placeholder="Data Início"
          ></b-form-input>
        </b-form-group>
      </div>
      <div class="col-md-4">
        <b-form-group label="Data Término:">
          <b-form-input
            type="date"
            v-model="transacao.DATA_TERMINO"
            placeholder="Data Término"
          ></b-form-input>
        </b-form-group>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <b-form-group label="Data Fidelização:">
          <b-form-input
            type="date"
            v-model="transacao.DATA_FIDELIZACAO"
            placeholder="Data Fidelização"
          ></b-form-input>
        </b-form-group>
      </div>
      <div class="col-md-4">
        <InputValor v-model="transacao.VALOR" ref="valor" />
      </div>
      <div class="col-md-4">
        <b-form-group label="Próximo Reajuste:">
          <b-form-input
            type="date"
            v-model="transacao.DATA_PROX_REAJUSTE"
            placeholder="Próximo Reajuste"
          ></b-form-input>
        </b-form-group>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <b-form-group label="Tipo do Vencimento:">
          <b-form-radio-group
            v-model="transacao.TIPO_VENCIMENTO"
            :options="opcoesTiposVencimento"
            name="radio-inline-tipovencimento"
          ></b-form-radio-group>
        </b-form-group>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <b-form-group label="Vencimento em dia útil:">
          <b-form-checkbox
            v-model="transacao.VENCIMENTO_EM_DIA_UTIL"
            name="checkbox-vencimentodiautil"
            value="1"
            unchecked-value="0"
          >
            Sim
          </b-form-checkbox>
        </b-form-group>
        <b-form-group label="Opções">
          <b-form-radio-group
            v-model="transacao.DIA_UTIL_ANTES_OU_DEPOIS"
            :options="opcoesDiaUtilAntesDepois"
            name="radio-inline-diautilantesdepois"
            stacked
          ></b-form-radio-group>
        </b-form-group>
      </div>
      <div class="col-md-4">
        <b-form-group label="Dia Vencimento:">
          <b-form-input
            type="text"
            v-model="transacao.DIA_VENCIMENTO"
            placeholder="Dia Vencimento"
          ></b-form-input>
        </b-form-group>
        <b-form-group label="Mês Vencimento:">
          <b-form-input
            type="text"
            v-model="transacao.MES_VENCIMENTO"
            placeholder="Mês Vencimento"
          ></b-form-input>
        </b-form-group>
      </div>
      <div class="col-md-4">
        <b-form-group label="Tipo Exercício:" style="">
          <b-form-radio-group
            v-model="transacao.TIPO_EXERCICIO"
            :options="opcoesTipoExercicio"
            name="radio-inline-tipoexercicio"
            stacked
          ></b-form-radio-group>
        </b-form-group>
        <b-form-group label="Exercício">
            <b-form-input
              type="text"
              v-model="transacao.EXERCICIO"
              placeholder="Exercício"
            ></b-form-input>
          </b-form-group>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <SearchBoxEmpresa ref="empresa" v-model="transacao.ID_EMPRESA" />
      </div>
      <div class="col-md-4">
        <SearchBoxCentroResponsabilidade ref="centroDeResponsabilidade" v-model="transacao.ID_CENTRO_RESPONSABILIDADE" />
      </div>
      <div class="col-md-4">
        <b-form-group label="Tipo Documento:">
          <b-form-select
            v-model="transacao.DOCUMENTO_TIPO"
            :options="opcoesTipoDocumento"
          ></b-form-select>
        </b-form-group>
      </div>
    </div>
    <div class="row" style="margin-top: 20px;">
      <div class="col-md-4">
        <SearchBoxProjeto ref="projeto" v-model="transacao.ID_PROJETO" />
      </div>
      <div class="col-md-4">
        <SearchBoxTipoMulta ref="tipoMulta" v-model="transacao.ID_TIPO_DE_MULTA" />
      </div>
      <div class="col-md-4">
        <b-form-checkbox
          v-model="transacao.DOCUMENTO_FISCAL"
          name="checkbox-docfiscalservico"
          value="1"
          unchecked-value="0"
        >
          Documento Fiscal de Serviço
        </b-form-checkbox>
        <b-form-checkbox
          v-model="transacao.ABATE_IMPOSTO"
          name="checkbox-abateimposto"
          value="1"
          unchecked-value="0"
        >
          Abate Imposto
        </b-form-checkbox>
        <b-form-checkbox
          v-model="transacao.E_PROVISAO"
          name="checkbox-provisao"
          value="1"
          unchecked-value="0"
        >
          Provisão
        </b-form-checkbox>
      </div>
    </div>
    <div class="row" style="margin-top: 20px;">
      <div class="col-md-4">
        <SearchBoxPortador ref="portador" v-model="transacao.ID_PORTADOR" />
      </div>
      <div class="col-md-4">
        <SearchBoxNaturezaOperacao ref="naturezaOperacao" v-model="transacao.ID_NATUREZA_OPERACAO"/>
      </div>
      <div class="col-md-4">
        <b-form-group label="Local Contrato:">
          <b-form-input
            type="text"
            v-model="transacao.CONTRATO_LOCALIZACAO"
            placeholder="Local Contrato"
          ></b-form-input>
        </b-form-group>
      </div>
    </div>
    <div class="row" style="margin-top: 20px;">
      <div class="col-md-12">
        <b-form-group label="Observações:">
            <b-form-textarea
              v-model="transacao.OBSERVACAO"
              placeholder="Observações"
              rows="8"
            ></b-form-textarea>
          </b-form-group>
      </div>
    </div>
  </FormCadastro>
</template>

<script>
import { mapActions } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

import FormCadastro from "@/../../components-spirit/FormCadastro/FormCadastro.vue";

import SearchBoxEmitente from "@/../../components-spirit/SearchBox/SearchBoxEmitente.vue";
import SearchBoxPlanoFinanceiro from "@/../../components-spirit/SearchBox/SearchBoxPlanoFinanceiro.vue";
import SearchBoxEmpresa from "@/../../components-spirit/SearchBox/SearchBoxEmpresa.vue";
import SearchBoxCentroResponsabilidade from "@/../../components-spirit/SearchBox/SearchBoxCentroResponsabilidade.vue";
import SearchBoxProjeto from "@/../../components-spirit/SearchBox/SearchBoxProjeto.vue";
import SearchBoxTipoMulta from "@/../../components-spirit/SearchBox/SearchBoxTipoMulta.vue";
import SearchBoxPortador from "@/../../components-spirit/SearchBox/SearchBoxPortador.vue";
import SearchBoxNaturezaOperacao from "@/../../components-spirit/SearchBox/SearchBoxNaturezaOperacao.vue";

import InputValor from "@/../../components-spirit/Inputs/InputValor.vue";

import Swal from "sweetalert2";

export default {
  name: "TransacaoProgramada",
  components: {
    FormCadastro,
    SearchBoxEmitente,
    SearchBoxPlanoFinanceiro,
    SearchBoxEmpresa,
    SearchBoxCentroResponsabilidade,
    SearchBoxProjeto,
    SearchBoxTipoMulta,
    SearchBoxPortador,
    SearchBoxNaturezaOperacao,
    InputValor
  },
  data() {
    return {
      loading: false,
      exibirBotoes: true,
      transacaoVazia: {},
      transacao: {
        ID_TRANSACAO_PROGRAMADA: "",
        ID_EMITENTE: "",
        ID_PLANO_FINANCEIRO: "",
        ID_EMPRESA: "",
        ID_CENTRO_RESPONSABILIDADE: "",
        ID_PROJETO: "",
        ID_TIPO_DE_MULTA: "",
        ID_PORTADOR: "",
        ID_NATUREZA_OPERACAO: "",
        PAGAR_RECEBER: "R",
        DESCRICAO: "",
        DATA_INICIO: "",
        DATA_TERMINO: "",
        DATA_FIDELIZACAO: "",
        VALOR: "",
        DATA_PROX_REAJUSTE: "",
        TIPO_VENCIMENTO: "U",
        VENCIMENTO_EM_DIA_UTIL: "0",
        DIA_UTIL_ANTES_OU_DEPOIS: "D",
        DIA_VENCIMENTO: "",
        MES_VENCIMENTO: "",
        TIPO_EXERCICIO: "P",
        DOCUMENTO_TIPO: "",
        DOCUMENTO_FISCAL: "0",
        ABATE_IMPOSTO: "0",
        E_PROVISAO: "0",
        CONTRATO_LOCALIZACAO: "",
        OBSERVACAO: "",
        DATA_INCLUSAO: "",
        USUARIO_INCLUSAO: "",
        DATA_ALTERACAO: "",
        USUARIO: ""
      },
      opcoesTiposVencimento: [
        { text: "Semanal", value: "S" },
        { text: "Quinzenal", value: "Q" },
        { text: "Mensal dia fixo", value: "M" },
        { text: "Mensal dia útil", value: "U" },
        { text: "Anual", value: "A" },
        { text: "Cobrança Registrada", value: "C" }
      ],
      opcoesDiaUtilAntesDepois: [
        { text: "Dia Anterior", value: "D" },
        { text: "Próximo dia", value: "P" }
      ],
      opcoesTipoExercicio: [
        { text: "Período Atual", value: "P" },
        { text: "Período Anterior", value: "A" },
        { text: "Configurado", value: "C" }
      ],
      opcoesTipoDocumento: [
        { value: "", text: "Selecione o tipo do documento" },
        { value: "Documento", text: "Documento" },
        { value: "Duplicata", text: "Duplicata" },
        { value: "Deb. Aut.", text: "Deb. Aut." }
      ],
      botoesMenu: [
        {
          title: "Excluir",
          evento: "excluir",
          exibir: true
        }
      ]
    };
  },
  async mounted() {
    Object.keys(this.transacao).forEach((item) => this.transacaoVazia[item] = this.transacao[item]);
    if ((this.$route.params.id) && (this.$route.params.id != '0')) {
      this.$store.dispatch(SET_BREADCRUMB, [
        { title: "Alterar transação programada" }
      ]);

      this.loading = true;

      let transacao = await this.getTransacaoProgramada(this.$route.params.id);
      this.atribuirObj(transacao);

      this.loading = false;
    } else {
      this.$store.dispatch(SET_BREADCRUMB, [
        { title: "Incluir transação programada" }
      ]);
    }
  },
  methods: {
    ...mapActions(["getTransacaoProgramada", "deleteTransacaoProgramada", "updateTransacaoProgramada"]),
    atribuirObj(transacao) {
      Object.keys(transacao.TRANSACAO).forEach((item) => this.transacao[item] = transacao.TRANSACAO[item]);

      this.$nextTick(() => {
        if(this.transacao.ID_EMITENTE) {
          this.$refs.emitente.selecionar({
            ID: this.transacao.ID_EMITENTE,
            DESCRICAO: transacao.INFOS.EMITENTE
          });
        }
        if(this.transacao.ID_PLANO_FINANCEIRO) {
          this.$refs.planoFinanceiro.selecionar({
            ID: this.transacao.ID_PLANO_FINANCEIRO,
            DESCRICAO: transacao.INFOS.PLANO_FINANCEIRO
          });
        }
        if(this.transacao.ID_EMPRESA) {
          this.$refs.empresa.selecionar({
            ID: this.transacao.ID_EMPRESA,
            DESCRICAO: transacao.INFOS.EMPRESA
          });
        }
        if(this.transacao.ID_CENTRO_RESPONSABILIDADE) {
          this.$refs.centroDeResponsabilidade.selecionar({
            ID: this.transacao.ID_CENTRO_RESPONSABILIDADE,
            DESCRICAO: transacao.INFOS.CENTRO_RESPONSABILIDADE
          });
        }
        if(this.transacao.ID_PROJETO) {
          this.$refs.projeto.selecionar({
            ID: this.transacao.ID_PROJETO,
            DESCRICAO: transacao.INFOS.PROJETO
          });
        }
        if(this.transacao.ID_TIPO_DE_MULTA) {
          this.$refs.tipoMulta.selecionar({
            ID: this.transacao.ID_TIPO_DE_MULTA,
            DESCRICAO: transacao.INFOS.TIPO_DE_MULTA
          });
        }
        if(this.transacao.ID_PORTADOR) {
          this.$refs.portador.selecionar({
            ID: this.transacao.ID_PORTADOR,
            DESCRICAO: transacao.INFOS.PORTADOR
          });
        }
        if(this.transacao.ID_NATUREZA_OPERACAO) {
          this.$refs.naturezaOperacao.selecionar({
            ID: this.transacao.ID_NATUREZA_OPERACAO,
            DESCRICAO: transacao.INFOS.NATUREZA_OPERACAO
          });
        }
      });
    },
    async clickMenu(opcao) {
      if(opcao == "excluir") {
        let e = await Swal.fire({
          title: "",
          text: "Deseja realmente excluir essa transação programada?",
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "Sim, excluir!",
          cancelButtonText: "Cancelar"
        });

        if (e.value) {
          let resposta = await this.deleteTransacaoProgramada(this.transacao.ID_TRANSACAO_PROGRAMADA);

          if (!resposta.resultado) {
            Swal.fire({
              title: "",
              text: "Ocorreu um erro e não foi possível excluir a transação programada.",
              icon: "error",
              confirmButtonClass: "btn btn-secondary"
            });
          } else {
            Swal.fire({
              title: "",
              text: "A transação programada foi excluída com sucesso.",
              icon: "success",
              confirmButtonClass: "btn btn-secondary"
            });

            this.voltar();
          }
        }
      }
    },
    hasHistory () {
      return window.history.length > 2;
    },
    voltar() {
      if(this.hasHistory()) {
        this.$router.go(-1);
      } else {
        this.$router.push('/transacoesprogramadas');
      }
    },
    trocouPagarReceber() {
      this.$refs.planoFinanceiro.apagar();
    },
    validarObjTransacao(obj) {
      let retorno = "";

      if (!obj.DESCRICAO) {
        retorno = "A descrição da transação programada é um campo obrigatório.";
      }

      return retorno;
    },
    async salvar(tipo) {
      let obj = {};

      Object.keys(this.transacaoVazia).forEach((item) => obj[item] = this.transacao[item]);

      let retorno = this.validarObjTransacao(obj);

      if (retorno) {
        Swal.fire({
          title: "Aviso",
          text: retorno,
          icon: "warning",
          timer: 3000,
          showConfirmButton: false
        });
      } else {
        this.loading = true;

        let retornoObj = await this.updateTransacaoProgramada(obj);

        if (retornoObj.USUARIO_INCLUSAO) {
          this.transacao.USUARIO_INCLUSAO = retornoObj.USUARIO_INCLUSAO;
        }
        if (retornoObj.USUARIO) {
          this.transacao.USUARIO = retornoObj.USUARIO;
        }
        if (retornoObj.DATA_INCLUSAO) {
          this.transacao.DATA_INCLUSAO = retornoObj.DATA_INCLUSAO;
        }
        if (retornoObj.DATA_ALTERACAO) {
          this.transacao.DATA_ALTERACAO = retornoObj.DATA_ALTERACAO;
        }
        this.loading = false;

        Swal.fire({
          title: "Aviso",
          text: "Transação salva com sucesso.",
          icon: "success",
          timer: 3000,
          showConfirmButton: false
        });

        if (tipo === 0) {
          this.voltar();
        } else if (tipo === 1) {
          this.$router.push({ path: "/transacaoprogramada/" + retornoObj.ID_TRANSACAO_PROGRAMADA });
        } else if (tipo === 2) {
          this.limparForm();
          this.$router.push({ path: "/transacaoprogramada" });
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>